import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import "../../scss/v2/legal.scss"

function Cookie(props) {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        i18n.changeLanguage(props.lang);
    }, [i18n, props.lang])

    return (
        <div className="legal container">
            <Helmet>
                <title>{t("meta.title.cookie")}</title>
                <meta name="description" content={t("meta.description.cookie")} />
                <meta name="robots" content="noindex" />
            </Helmet>
            <h1 className="legal-title">{t('legal.cookie.title')}</h1>
            <div className="legal-text" dangerouslySetInnerHTML={{ __html: t('legal.cookie.text') }}  />
        </div>
    )

}

export default Cookie